import { ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from 'antd';

/**
 * 显示一个确认模态框
 * @param {Object} options - 模态框配置选项
 * @param {string} [options.title] - 模态框标题，默认为“系统繁忙，请联系客服人员或稍后再试！”
 * @param {string} [options.message] - 模态框内容，默认为空字符串
 * @param {ReactNode} [options.icon] - 模态框图标，默认为红色的 ExclamationCircleFilled
 * @param {string} [options.okText] - 确定按钮文字，默认为“确定”
 * @param {boolean} [options.closable=true] - 是否显示关闭按钮
 * @param {string} [options.className='lc-antd-modal'] - 模态框样式类
 * @param {boolean} [options.centered=true] - 是否居中显示
 * @param {Function} [options.onOk=() => Modal.destroyAll()] - 确定按钮回调函数
 * @param {Function} [options.onCancel=() => {}] - 取消按钮回调函数
 */

export default class lcMsgTips {
  static showConfirmModal = ({
    title = '系统繁忙，请联系客服人员或稍后再试！',
    message = '',
    icon = <ExclamationCircleFilled style={{ color: 'red' }} />,
    okText = '确定',
    closable = false,
    className = 'lc-antd-modal',
    centered = true,
    onOk = () => Modal.destroyAll(),
    onCancel = () => {},
    mask = false,
  }) => {
    return Modal.confirm({
      title: <span className="text-[14px]">{title}</span>,
      icon: icon,
      closable: closable,
      className: className,
      centered: centered,
      mask: mask,
      content: (
        <div className="text-[14px]">
          <div>{message}</div>
          <div className="mt-[30px] flex justify-end">
            <button
              className="bg-lcBlue ml-[15px] h-[32px] rounded-[4px] pl-[15px] pr-[15px] text-[white] hover:opacity-[0.8]"
              onClick={() => {
                onOk();
                Modal.destroyAll();
              }}
            >
              {okText}
            </button>
          </div>
        </div>
      ),
      onOk: () => {
        onOk();
      },
      onCancel: () => {
        onCancel();
        Modal.destroyAll();
      },
    });
  };
}
